import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[ssgListItem]' })
export class MultiSelectListItemTemplateDirective {
  constructor(public template: TemplateRef<any>) { }
}

@Directive({ selector: '[ssgSelectedItem]' })
export class MultiSelectSelectedItemTemplateDirective {
  constructor(public template: TemplateRef<any>) { }
}
